// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__lD8yL","box":"styles_box__bJVoV","text":"styles_text__-Sfkz","title":"styles_title__ug-FX"};